export const HOME_FAQS = [
  {
    q: "How much does an elevator cost in Bangalore?",
    a: "In Bangalore, a home lift for a villa typically costs ₹6.5–10 lakhs, a passenger elevator for a residential apartment ₹8–14 lakhs, and commercial or hospital elevators ₹11–20+ lakhs depending on floors, capacity and cabin finish. Vila Elevators manufactures in-house at Bommasandra, Bengaluru, which keeps pricing 15–25% below imported brands. Use our free cost calculator or call +91 90712 21100 for an exact quote.",
  },
  {
    q: "Who is the best elevator manufacturer in Bangalore?",
    a: "Vila Elevators & Escalators is a Bangalore-based elevator manufacturer with a full in-house CNC production facility at Bommasandra Industrial Area. Unlike dealers who resell imported units, Vila manufactures cabins, doors and controller enclosures locally, provides IoT-enabled smart controllers with web-app monitoring on every lift, and services Karnataka, Tamil Nadu, Telangana and Andhra Pradesh with 24×7 support.",
  },
  {
    q: "What is the delivery and installation time for a new elevator?",
    a: "Because Vila manufactures in-house in Bengaluru, standard passenger elevators and home lifts are typically manufactured, delivered and installed within 8–12 weeks from order confirmation — faster than the 4–6 months common with imported brands. Escalators and custom cabins may take longer depending on specifications.",
  },
  {
    q: "Does Vila Elevators provide AMC (Annual Maintenance Contract)?",
    a: "Yes. Vila offers comprehensive and non-comprehensive AMC plans covering preventive maintenance visits, 24×7 emergency breakdown response, and genuine spare parts. Every Vila elevator also includes an intelligent controller with remote diagnostics, so our service team often detects issues before you call.",
  },
  {
    q: "Which cities does Vila Elevators serve?",
    a: "Vila Elevators & Escalators serves Bangalore, Mysuru, Mangaluru (Karnataka), Chennai, Coimbatore (Tamil Nadu), Hyderabad (Telangana), Vijayawada and Visakhapatnam (Andhra Pradesh), plus surrounding regions across all four South Indian states.",
  },
  {
    q: "What is a smart or IoT-enabled elevator?",
    a: "Every Vila elevator ships with an industry-leading intelligent controller connected to the Vila web app. Owners and facility managers can monitor live elevator status, floor position, ride counts, health scores and receive instant breakdown or maintenance alerts from any phone or computer — no app download required.",
  },
  {
    q: "Are Vila elevators compliant with Indian safety standards?",
    a: "Yes. All Vila elevators and escalators are engineered to meet or exceed IS 14665 (Indian Standard for electric traction lifts) and applicable state lift rules, with features like automatic rescue devices (ARD), overload sensors, door safety curtains and emergency communication systems.",
  },
  {
    q: "Can old elevators be modernized instead of replaced?",
    a: "Usually yes. Vila modernizes legacy elevators by upgrading controllers, drives, doors and cabin interiors while retaining the existing shaft and structure. Modernization typically costs 40–60% of a full replacement, cuts energy use by up to 40%, and adds smart monitoring capability.",
  },
];

export const PRODUCT_FAQS = {
  "passenger-elevators": [
    {
      q: "What is the price of a passenger elevator in India?",
      a: "A Vila passenger elevator for a residential apartment starts around ₹8–9 lakhs for a 4-floor, 8-passenger configuration with standard steel finish. Commercial and high-capacity configurations range from ₹11–20 lakhs. Final pricing depends on floors, load, drive type and cabin finish — request a free site survey for an exact quote.",
    },
    {
      q: "What is the difference between MRL and geared elevators?",
      a: "MRL (Machine Room-Less) elevators mount the motor inside the shaft, saving the cost and space of a rooftop machine room and reducing energy use by up to 40%. Geared traction elevators use a conventional machine room and suit very high-rise or heavy-duty applications. Vila manufactures both.",
    },
    {
      q: "How many floors can a Vila passenger elevator serve?",
      a: "Vila passenger elevators are configured from G+1 up to G+15 and beyond, with speeds from 0.5 to 1.75 m/s and capacities from 4 to 20+ passengers (272 kg to 1350+ kg).",
    },
    {
      q: "Do Vila passenger elevators include smart monitoring?",
      a: "Yes. Every Vila passenger elevator includes an IoT-enabled intelligent controller with the Vila web app for real-time health monitoring, ride analytics, instant breakdown alerts and remote diagnostics.",
    },
  ],
  "home-lifts": [
    {
      q: "How much does a home lift cost in Bangalore?",
      a: "A Vila home lift for a villa or duplex in Bangalore typically costs ₹6.5–8 lakhs for a standard 2–3 floor, 4-person configuration, and ₹8–12 lakhs for premium stainless or luxury custom finishes. In-house manufacturing at our Bommasandra facility keeps prices below imported home lift brands.",
    },
    {
      q: "How much space is needed for a home lift?",
      a: "Vila compact home lifts fit in shafts as small as about 1000 mm × 1000 mm, and pitless / low-headroom options are available for retrofits in existing homes where civil work must be minimal.",
    },
    {
      q: "Hydraulic or traction home lift — which is better?",
      a: "Hydraulic home lifts are quieter at low rises, need no overhead machine room and suit 2–4 floors. Traction (MRL) home lifts are more energy-efficient for frequent use and taller homes. Vila manufactures both and recommends the right type after a free site survey.",
    },
    {
      q: "Does a home lift need a licence in Karnataka?",
      a: "Requirements vary by state. In Karnataka, lifts in private single-family residences are generally exempt from commercial lift licensing, but safety standards still apply. Vila handles compliance documentation and builds every home lift to IS 14665-aligned safety norms.",
    },
  ],
  "freight-elevators": [
    {
      q: "What load capacity do Vila freight elevators support?",
      a: "Vila freight and cargo elevators are built for 500 kg to 5000+ kg payloads with reinforced platforms, heavy-duty doors and industrial-grade drives — suitable for factories, warehouses, and logistics hubs.",
    },
    {
      q: "How much does a freight elevator cost?",
      a: "Freight elevator pricing starts around ₹10–12 lakhs for a standard 1000 kg, 2-level goods lift and scales with capacity, travel height and door configuration. Vila provides exact quotes after a free site survey.",
    },
    {
      q: "Can freight elevators be installed in existing factories?",
      a: "Yes. Vila engineers structural-steel shaft solutions for retrofits where no concrete shaft exists, minimizing civil work and production downtime during installation.",
    },
  ],
  "hospital-lifts": [
    {
      q: "What makes a hospital lift different from a passenger lift?",
      a: "Hospital (stretcher) lifts have deeper cabins sized for stretchers and beds (typically 1000×2400 mm or larger), smoother leveling accuracy for patient safety, antibacterial finishes, and battery-backed automatic rescue devices. Vila builds them to IS 14665 and healthcare facility norms.",
    },
    {
      q: "What is the cost of a hospital elevator in India?",
      a: "Vila hospital / stretcher lifts typically range from ₹13–22 lakhs depending on floors, capacity (usually 15–26 passengers / 1020–1768 kg) and finish. Request a free site survey for a precise quote.",
    },
    {
      q: "Do hospital lifts include emergency backup?",
      a: "Yes. Every Vila hospital lift includes an Automatic Rescue Device (ARD) that brings the cabin to the nearest floor during power failure, plus emergency communication and battery-backed lighting.",
    },
  ],
  escalators: [
    {
      q: "How much does an escalator cost in India?",
      a: "Commercial escalators in India typically cost ₹35–80+ lakhs per unit depending on rise height, step width, and duty class (commercial vs heavy-duty transit). Vila provides detailed proposals after assessing site traffic and structural requirements.",
    },
    {
      q: "Where are Vila escalators suitable?",
      a: "Vila escalators serve malls, retail complexes, metro stations, airports, hotels and office buildings across South India, with 30° and 35° inclinations, 600–1000 mm step widths and energy-saving auto start-stop operation.",
    },
    {
      q: "What maintenance do escalators require?",
      a: "Escalators need monthly preventive maintenance covering step chains, handrails, combs and safety switches. Vila AMC programs include scheduled visits, 24×7 breakdown response and genuine spares across Karnataka, Tamil Nadu, Telangana and Andhra Pradesh.",
    },
  ],
  "moving-walkways": [
    {
      q: "What is a moving walkway and where is it used?",
      a: "A moving walkway (travelator) is a horizontal or slightly inclined conveyor for pedestrians, used in airports, large malls, hypermarkets and transit hubs. Vila supplies 0°–12° inclination walkways with 800–1400 mm pallet widths.",
    },
    {
      q: "Can moving walkways carry shopping trolleys?",
      a: "Yes. Vila inclined walkways are designed with trolley-lock pallet grooving so shopping carts lock safely in place — the standard solution for hypermarkets and multi-level retail.",
    },
  ],
};

export const cityFaqs = (city) => [
  {
    q: `How much does an elevator cost in ${city.name}?`,
    a: `In ${city.name}, a Vila home lift typically costs ₹6.5–10 lakhs and a passenger elevator ₹8–14 lakhs, depending on floors, capacity and finish. Vila manufactures in-house in Bengaluru and delivers, installs and services across ${city.name}, ${city.state} — request a free site survey for an exact quote.`,
  },
  {
    q: `Does Vila Elevators provide installation in ${city.name}?`,
    a: `Yes. Vila Elevators & Escalators installs passenger elevators, home lifts, freight lifts, hospital lifts and escalators across ${city.name} and surrounding areas of ${city.state}, with dedicated site-survey and installation teams.`,
  },
  {
    q: `Is elevator AMC and emergency service available in ${city.name}?`,
    a: `Yes. Vila offers Annual Maintenance Contracts in ${city.name} with preventive service visits and 24×7 emergency breakdown response. Every Vila lift also has IoT remote diagnostics, so issues are often detected before you call.`,
  },
  {
    q: `Can old lifts in ${city.name} buildings be modernized?`,
    a: `Yes. Vila modernizes legacy elevators in ${city.name} by upgrading controllers, drives, doors and cabins while keeping the existing shaft — typically at 40–60% of replacement cost, with reduced energy use and added smart monitoring.`,
  },
  {
    q: `How do I get an elevator quote in ${city.name}?`,
    a: `Call +91 90712 21100, WhatsApp us, or submit the quote form on this page. Vila responds within one business day and schedules a free site survey anywhere in ${city.name}, ${city.state}.`,
  },
];
